// const BASEURL = 'https://pos.lkmng.com/api/'
// const BASESYNCURL = 'https://pos.lkmng.com/mobile-api/'
const BASEURL = 'https://api.optimy.com.my/api/'
const BASESYNCURL = 'https://api.optimy.com.my/mobile-api/'

export { BASEURL, BASESYNCURL}
